import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { RolesEnum } from '@irembo-andela/irembogov3-common';
import { IServiceChangeRequest } from '../../../../core/models/service-change-request.model';
import { UserCanViewServiceChangeRequests } from '../../../../core/config/service-change-request.config';

@Component({
  selector: 'irembogov-service-change-request-viewer-action-widget',
  templateUrl: './service-change-request-viewer-action-widget.component.html',
})
export class ServiceChangeRequestViewerActionWidgetComponent
  implements OnInit, OnDestroy
{
  @Input() changeRequest!: IServiceChangeRequest;
  @Input() isProcessing = false;
  userActiveRole!: RolesEnum;
  private userActiveRole$ = new Subject<void>();

  @Output() OnViewClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.userActiveRole$.subscribe(newRole => {
      if (newRole === 'UNKNOWN_ROLE') {
        this.initializeRoles();
      } else {
        this.userActiveRole = newRole;
      }
    });
  }

  checkIfCanViewChangeRequests() {
    if (!this.userActiveRole) return false;
    return UserCanViewServiceChangeRequests.indexOf(this.userActiveRole) > -1;
  }

  ngOnDestroy(): void {
    this.userActiveRole$.next();
    this.userActiveRole$.complete();
  }

  async initializeRoles() {
    const firstAllowedRole = await this.authService.firstAllowedRole();

    if (firstAllowedRole) {
      this.userActiveRole = firstAllowedRole;
    }
  }
}
